import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AccountService } from './_services';
import { User } from './_models';
import { Dealer } from './_models/dealer';
import { DealerService } from './_services/dealer-service';

@Component({ selector: 'app', templateUrl: 'app.component.html' })
export class AppComponent implements OnInit, OnDestroy {
    user: User;
    dealer: Dealer;
    showReceivableTab = false;
    showCancellationPolicy = false;
    private destroy$ = new Subject<void>();

    constructor(private accountService: AccountService, private dealerService: DealerService) {}

    ngOnInit() {
        this.accountService.getLoggedInUserChange
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.loadUserData();
            });
        this.loadUserData();
    }

    private loadUserData() {
        this.user = this.accountService.userValue;
        if (this.user) {
            if (this.user.role != "admin" && this.user.role != "employee") {
                this.dealerService.getByDealerId(this.user.dealerId)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe((y) => {
                        this.dealer = y;
                        this.showReceivableTab = this.dealer.dealerInvoiceShow
                            ? this.dealer.dealerInvoiceShow == "No" ? false : true
                            : true;
                    });
            } else {
                this.showReceivableTab = false;
            }
        }
    }

    cancellationPolicyToggle() {
        this.showCancellationPolicy = !this.showCancellationPolicy;
    }

    contactUsToggle() {
        this.showCancellationPolicy = false;
    }

    logout() {
        this.accountService.logout();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
